var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#222222;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M590.5,1200c-12-5.6-22.1-14.7-28.9-26c-111.5-157.8-223.8-315-334.7-473.3c-42.2-60.7-67.8-131.5-74.2-205.2 c-18.7-192,85.1-376.7,261.1-452.9c170.9-74,332.3-51.5,476.8,67c43.6,35.4,79.7,79.1,106.4,128.5c26.6,49.4,43.3,103.6,48.9,159.5 c14.4,112.2-15,225.7-82.1,316.8c-107.9,152-215.9,304.3-324,456.8c-7,12.5-17.7,22.5-30.6,28.8L590.5,1200z M749.5,451.7 c0.2-39.6-15.4-77.7-43.2-105.8c-27.8-28.2-65.7-44.2-105.3-44.5c-39.6-0.3-77.7,15.1-106,42.8s-44.5,65.5-45,105.1 c-0.5,39.6,14.7,77.8,42.3,106.2c27.6,28.4,65.3,44.7,104.9,45.4c40,0.5,78.5-15,107.1-43C732.9,529.9,749.2,491.7,749.5,451.7 L749.5,451.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.0363ec8e36d5f64aa92f223ba20a63b7.svg";
export { ForwardRef as ReactComponent };